// extracted by mini-css-extract-plugin
export default {"body_wrapper":"CompetitionPerformance_body_wrapper__amYNH","metricBoxCustomHeight":"CompetitionPerformance_metricBoxCustomHeight__ArZhS","icon":"CompetitionPerformance_icon__QUpKX"};